export default __webpack_public_path__ + "static/media/fortune-life.d83cdb87.png";